import type { TableVariant } from './table';

export const tableCellStyles = (variant: TableVariant = 'default'): string => {
  const th =
    variant === 'default'
      ? '[&_th]:text-[0.75rem] [&_th]:font-medium [&_th]:leading-4 [&_th]:bg-secondary [&_th]:p-[12px] [&_th:first-child]:pl-[20px] [&_th:last-child]:pr-[20px]'
      : '[&_th]:text-[0.8125rem] [&_th]:font-normal [&_th]:leading-4 [&_th]:p-[2px] [&_th:first-child]:pl-0 [&_th:last-child]:pr-0';

  const td =
    variant === 'default'
      ? '[&_td]:text-[0.875rem] [&_td]:font-normal [&_td]:leading-5 [&_td]:h-[46px] [&_td]:px-[12px] [&_td]:py-0 [&_tbody_td:first-child]:pl-[20px] [&_tbody_td:last-child]:pr-[20px]'
      : '[&_td]:text-[0.8125rem] [&_td]:font-normal [&_td]:leading-4 [&_td]:h-[32px] [&_td]:px-[2px] [&_td]:py-0 [&_tbody_td:first-child]:pl-0 [&_tbody_td:last-child]:pr-0';

  return [
    '[&_th]:border-b [&_th]:border-tertiary [&_th]:text-secondary',
    th,
    '[&_td]:text-primary [&_td]:align-middle [&_td]:overflow-hidden [&_td]:text-ellipsis [&_td]:whitespace-nowrap',
    '[&_td_p]:overflow-hidden [&_td_p]:text-ellipsis [&_td_p]:whitespace-nowrap',
    td,
    variant === 'default'
      ? '@max-[48rem]:[&_th:first-child]:pl-3 @max-[48rem]:[&_th:last-child]:pr-3 @max-[48rem]:[&_tbody_td:first-child]:pl-3 @max-[48rem]:[&_tbody_td:last-child]:pr-3'
      : '',
    '[&_tbody_tr:not(:last-child)_td]:border-b [&_tbody_tr:not(:last-child)_td]:border-tertiary',
  ].join(' ');
};
